import { Address } from "src/api/address";
import { getAddressDataById, isValidAddress } from "src/utils/address";
import { ROUTE_PATHS } from "src/utils/constants";

export const hasInvalidateAddress = (id: number, address: Address[]) => {
  if (!!id) {
    const currentAddress = getAddressDataById(address, id);
    return !!currentAddress && !isValidAddress(currentAddress);
  } else {
    return !!id;
  }
};

export const hasProducts = (myProductsListResponse) => {
    return myProductsListResponse?.pages?.length > 0 && myProductsListResponse?.pages[0]?.content?.length > 0
}

export const routeValidations = () => {
  return !(window?.location?.pathname?.includes(ROUTE_PATHS.PROFILE) || window?.location?.pathname?.includes(ROUTE_PATHS.CART))
}